module.exports = __webpack_public_path__ + "img/icon.5dff8cdd.png";